<template>
  <div>
    <t-form ref="form" @submit.prevent>
      <EstimatedNumberOfFramesFormPart @change="onChange" @result="onResult" />

      <h2 class="form-modal__part-title">Wat wilt u laten plaatsen?</h2>

      <WhatTypeOfFramesFormPart @change="onChange" @result="onResult" />
    </t-form>

    <FormErrorMessages :error-messages="errorMessages" />
  </div>
</template>

<script>
import AbstractFormStep from 'chimera/all/components/form/steps/AbstractFormStep'
import FormErrorMessages from 'chimera/all/components/form/FormErrorMessages'
import EstimatedNumberOfFramesFormPart from '~/components/form/parts/estimatedNumberOfFrames/EstimatedNumberOfFramesFormPart.PD-10940'
import WhatTypeOfFramesFormPart from '~/components/form/parts/whatTypeOfFrames/WhatTypeOfFramesFormPart.PD-10940'
import NextStep from '~/pages/offertes-aanvragen/uw-gegevens'

export default {
  name: 'EstimatedNumberOfFramesWhatTypeOfFramesFormStep',

  components: {
    EstimatedNumberOfFramesFormPart,
    WhatTypeOfFramesFormPart,
    FormErrorMessages,
  },

  extends: AbstractFormStep,

  data: () => ({
    willTransitionOnValid: true,
  }),

  /**
   * Pass through the submit event given from FormModal
   */
  created() {
    this.$nuxt.$on('submit', this.onSubmit)
  },

  /**
   * Clean up before component is destroyed
   */
  destroyed() {
    this.$nuxt.$off('submit')
  },

  methods: {
    /**
     * Transition
     */
    transition() {
      this.routeTo(NextStep)
    },
  },
}
</script>
